import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AuthForm from './components/AuthForm';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import UploadForm from './pages/UploadForm';
import Analytics from './pages/Analytics';
import Royalties from './pages/Royalties';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <main className="flex-grow">
                  <Home />
                </main>
                <Footer />
              </>
            }
          />
          <Route
            path="/pricing"
            element={
              <>
                <Navbar />
                <main className="flex-grow">
                  <Pricing />
                </main>
                <Footer />
              </>
            }
          />
          <Route
            path="/terms"
            element={
              <>
                <Navbar />
                <main className="flex-grow">
                  <Terms />
                </main>
                <Footer />
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                <Navbar />
                <main className="flex-grow">
                  <Privacy />
                </main>
                <Footer />
              </>
            }
          />

          {/* Auth Routes */}
          <Route
            path="/auth"
            element={!session ? <AuthForm /> : <Navigate to="/dashboard" replace />}
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={session ? <Dashboard /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/dashboard/upload"
            element={session ? <Upload /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/dashboard/upload/:type"
            element={session ? <UploadForm /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/dashboard/analytics"
            element={session ? <Analytics /> : <Navigate to="/auth" replace />}
          />
          <Route
            path="/dashboard/royalties"
            element={session ? <Royalties /> : <Navigate to="/auth" replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App